import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getPageLinkByNodeId, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PlayIconOutlined from "@tecumseh/Icons/PlayIconOutlined";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import * as cssLinter from "css";
import parse from "html-react-parser";
import React, { FC, useEffect, useRef } from "react";
import styled, { css } from "styled-components";

const enum fields {
    image = "image",
    title = "title",
    description = "description",
    video = "video",
    buttons = "buttons",
    customCSS = "customCSS",
    blurEffect = "blurEffect",
}

interface CustomButtonModel {
    fields: {
        openInNewTab: boolean;
        overriddenTitle: string;
        linktype: "link" | "file" | "video";
        destination: LinkFieldValue;
        file: string;
        video: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.title]: string;
        [fields.description]: string;
        [fields.video]: string;
        [fields.buttons]: CustomButtonModel[];
        [fields.customCSS]: string;
        [fields.blurEffect]: number;
    };
}

export interface HomePageBannerStyle {
    bannerTitle?: InjectableCss;
    bannerDescription?: InjectableCss;
    buttonWrapper?: InjectableCss;
    bannerTextContainer?: InjectableCss;
    button?: LinkPresentationProps;
    buttonContainer?: InjectableCss;
    wrapper?: InjectableCss;
    videoWrapper?: InjectableCss;
    videoTag?: InjectableCss;
    videoContainer?: InjectableCss;
    tabMainBanner?: InjectableCss;
    iframeBackgroundVideo?: InjectableCss;
}

export const StyledWrapperContainer = styled.div<{ blur?: number }>`
            min-height: 85vh;
            width: 100%;
            display: flex;
            flex-direction: column;
            z-index: 1;
            justify-content: center;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            min-height: 60vh;
                        `,
                        null,
                    ],
                    "max",
                )};

            &::after{
                content: "";
                height: 100%;
                width: 100%;
                position: absolute;
                backdrop-filter: ${({ blur }) =>
                    blur ? `blur(${blur}px)` : "blur(20px)"};
                z-index: -1;
            }
            `;

export const homePageBannerStyle: HomePageBannerStyle = {
    bannerTextContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            
        `,
    },
    bannerTitle: {
        css: css`
            font-size: 3.4rem;
            color: ${COLORS.white};
            font-family: ${TYPOGRAPHY.fontFamily.montserrat};
            font-weight: ${TYPOGRAPHY.weight.bold};
            margin: 0 !important;
            line-height: 60px;
            margin-bottom: 20px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-bottom: 10px;
                    `,
                    css`
                        width: 100%;
                        margin-bottom: 10px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    bannerDescription: {
        css: css`
            > p {
                color: ${COLORS.white};
                font-size: ${TYPOGRAPHY.size.base};
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: ${TYPOGRAPHY.size.base};
                            width: 100%;
                            margin-top: 10px;
                        `,
                        css`
                            font-size: ${TYPOGRAPHY.size.larger};
                            width: 100%;
                            margin-top: 10px;
                        `,
                        css`
                            width: 100%;
                            font-size: ${TYPOGRAPHY.size.larger};
                            margin-top: 10px;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    videoWrapper: {
        css: css`
            display: flex;
            width: 560px;
            height: 315px;
            > iframe {
                width: 100%;
                height: 100%;
            }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 85%;
                        height: auto;
                    `,
                    css`
                        width: 85%;
                        height: auto;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    buttonContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 15px;
            margin-top: 25px;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            gap: 15px;
                            display: flex;
                            flex-wrap: wrap;
                        `,
                        css`
                            gap: 15px;
                            display: flex;
                            flex-wrap: wrap;
                        `,
                        css`
                            gap: 15px;
                            display: flex;
                            flex-wrap: wrap;
                        `,
                        css`
                            
                        `,
                        null,
                    ],
                    "minMax",
                )}
        `,
    },
    wrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        null,
                    ],
                    "minMax",
                )};
            button,a {
                background-color: #f5f9fd;
                padding: 10px 20px;
                border-radius: 25px;
                :hover {
                    opacity: 0.8;
                    background-color: #13ea9d;
                }
            }
            button {
                >span{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    svg{
                        height: 19px;
                    }
                }
            }
            span {
                display: flex;
                align-items: center;
                color: ${COLORS.black} !important;
                font-size: ${TYPOGRAPHY.size.base};
                font-weight: ${TYPOGRAPHY.weight.baseBold} !important;
                font-family: ${TYPOGRAPHY.fontFamily.montserrat};
                &:hover {
                }
            }
        `,
        
    },
    videoContainer: {
        css: css`
            background: #000000db;
            z-index: 99;
            position: fixed;
            width: 100%;
            height: 100vh;
            top: 0px;
            left: 0px;
            display: flex;
            justify-content: center;
            align-items: center;
        `
    },
    tabMainBanner: {
        css: css`
            min-height: 85vh;
            width: 100%;
            display: flex;
            flex-direction: column;
            z-index: 1;
            justify-content: center;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            min-height: 60vh;
                        `,
                        null,
                    ],
                    "max",
                )};

            &::after{
                content: "";
                height: 100%;
                width: 100%;
                position: absolute;
                backdrop-filter: blur(20px);
                z-index: -1;
            }
            
        `
    },
    iframeBackgroundVideo: {
        css:css`        
            top: 50%;
            left: 50%;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            object-fit: cover;
            pointer-events: none;
            transform: scale(1.5);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            transform: scale(2.5);
                        `,
                        null,
                    ],
                    "max",
                )};

        `
    }
};

const styles = homePageBannerStyle;

// Helper to extract video ID from any YouTube URL
function getYouTubeVideoId(url: string): string | null {
    try {
        const parsed = new URL(url);
        if (parsed.hostname === "youtu.be") {
            return parsed.pathname.slice(1);
        }
        if (parsed.hostname.includes("youtube.com")) {
            return parsed.searchParams.get("v");
        }
    } catch (e) {
    }
    return null;
}

declare global {
    interface Window {
        YT?: any;
        onYouTubeIframeAPIReady?: () => void;
    }
}
export const TECHeroBannerVideoBackground: FC<OwnProps> = ({ fields }) => {
    const buttons = useGetLinks(fields.buttons, o => o.fields.destination);
    const [showVideo, setShowVideo] = React.useState("");

    const backgroundStyle = `background-image: url(${fields.image});`;

    const bannerWrapper = {
        css: css`
            padding: 0px;
            max-width: 100%;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [css``, css``, null, null, null])}
            ${fields.customCSS}
        `,
    };
    const videoRef = useRef<HTMLVideoElement | any | null>(null);

    useEffect(() => {
        if (videoRef.current) {
            if(!(fields.image.includes("youtube.com") || fields.image.includes("youtu.be"))){
                videoRef.current.play().catch((err:any) => {
                   
                });
            }
        }
    }, [fields.image]);

    const playerRef = useRef<HTMLDivElement>(null);
    const ytPlayerInstance = useRef<any>(null);

    useEffect(() => {
    if(fields.image.includes("youtube.com") || fields.image.includes("youtu.be")){
        const videoId = getYouTubeVideoId(fields.image);
        if (!videoId) return;

        function createPlayer(id: string) {
            if (playerRef.current && !ytPlayerInstance.current) {
                ytPlayerInstance.current = new window.YT.Player(playerRef.current, {
                    videoId: id,
                    playerVars: {
                        autoplay: 1,
                        mute: 1,
                        controls: 0,
                        playsinline: 1,
                        loop: 1,
                        playlist: id, // required for looping
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0,
                    },
                    events: {
                        onReady: (event: any) => {
                            event.target.mute();
                            event.target.playVideo();
                        },
                    },
                });
            }
        }

        // Load YouTube API if not loaded yet
        if (!window.YT) {
            window.onYouTubeIframeAPIReady = () => {
                createPlayer(videoId);
            };
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName("script")[0];
            if (firstScriptTag && firstScriptTag.parentNode) {
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            } else {
                document.body.appendChild(tag);
            }
        } else {
            createPlayer(videoId);
        }

        // Cleanup on unmount
        return () => {
            if (ytPlayerInstance.current && ytPlayerInstance.current.destroy) {
                ytPlayerInstance.current.destroy();
                ytPlayerInstance.current = null;
            }
        };
    }
    }, [fields.image]);

    return (
        <StyledWrapper className="hero-banner-wrapper" {...bannerWrapper}>            
            {fields.image.includes("youtube.com") || fields.image.includes("youtu.be") ? (
                    <StyledWrapper
                        style={{
                             position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            overflow: "hidden",
                            zIndex: 1,
                        }}
                        >
                        <StyledWrapper
                            ref={playerRef}
                            {...styles.iframeBackgroundVideo}
                        />
                        </StyledWrapper>
                        ) : fields.image.includes("vimeo.com") ? (
                        // 🎥 Vimeo Embed
                        <iframe
                            src={`https://player.vimeo.com/video/${fields.image.split("/").pop()}?autoplay=1&mute=1`}
                            width="640"
                            height="360"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title="Vimeo video player"
                        ></iframe>
                        ) : (
                        // 🎥 Direct file (mp4, mov, webm, etc.)
                        <video  ref={videoRef} style={{top: "0px",
                            left: "0",
                            zIndex: 1,
                            height: "100%",
                            position: "absolute",
                            width: "100%",
                            objectFit: "cover"}}  autoPlay muted loop playsInline src={fields.image}>
                            </video>
                        )}
            <StyledWrapperContainer blur={fields.blurEffect} id="TECmainbanner">
                <GridContainer style={{display:"flex", alignItems:"center", padding:"15px"}}>
                    <GridItem width={[12,12,10,9,6]} style={{flexDirection:"column",paddingTop:"40px",paddingBottom:"40px"}}>
                        <StyledWrapper {...styles.bannerTextContainer}>
                            <StyledWrapper {...styles.bannerTitle}>
                                 {parse(fields.title, parserOptions)}
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.bannerDescription}>
                            {parse(fields.description, parserOptions)}
                        </StyledWrapper>
                        <StyledWrapper {...styles.buttonContainer}>
                            {buttons.links.map((button, index) => {
                                const btnFields = fields.buttons[index].fields;
                                const href = btnFields.linktype === "file" && btnFields.file ? btnFields.file : button.url;
                                return (
                                    <StyledWrapper
                                        className="links-wrapper"
                                        key={index}
                                        {...styles.wrapper}
                                    >
                                        
                                        {
                                            btnFields.linktype === "link" && (
                                                <Link target={btnFields.openInNewTab ? "_blank" : ""} href={href}>
                                                    {btnFields.overriddenTitle}
                                                </Link>
                                            )
                                        }
                                        {
                                            btnFields.linktype === "video" && (<>
                                                <Link 
                                                    onClick={()=>{
                                                        setShowVideo(btnFields.video);
                                                    }}
                                                >
                                                 <Icon src={PlayIconOutlined}/>   {btnFields.overriddenTitle}
                                                </Link>
                                            </>
                                                
                                            )
                                        }
                                        {
                                            btnFields.linktype === "file" && (
                                                <Link onClick={()=>{const link = document.createElement("a");
                                                        link.href = btnFields.file;
                                                        link.download = "";
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                             }} >
                                                    {btnFields.overriddenTitle}
                                                </Link>
                                            )
                                        }
                                    </StyledWrapper>
                                );
                            })}
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </StyledWrapperContainer>
            {showVideo && (
                <StyledWrapper {...styles.videoContainer} 
                 onClick={() => setShowVideo("")}
                 >
                    <StyledWrapper onClick={(e) => e.stopPropagation()}>    
                        {showVideo.includes("youtube.com") || showVideo.includes("youtu.be") ? (
                        // YouTube Embed
                        <iframe
                            width="640"
                            height="360"
                            src={`https://www.youtube.com/embed/${
                            showVideo.includes("v=")
                                ? new URL(showVideo).searchParams.get("v")
                                : showVideo.split("/").pop()
                            }?autoplay=1&mute=1`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                        ) : showVideo.includes("vimeo.com") ? (
                        // Vimeo Embed
                        <iframe
                            src={`https://player.vimeo.com/video/${showVideo.split("/").pop()}?autoplay=1&mute=1`}
                            width="640"
                            height="360"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title="Vimeo video player"
                        ></iframe>
                        ) : (
                        // Direct file (mp4, mov, webm, etc.)
                        <video style={{maxWidth: "640px", width: "100%"}} height="360" autoPlay controls>
                            <source src={showVideo} />
                        </video>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                )}
        </StyledWrapper>
    );
};

const defaultCustomCss = `&.bannerWrapper-tecmain {

}`;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: TECHeroBannerVideoBackground,
    definition: {
        group: "Basic",
        displayName: "TEC Hero Banner Video Background",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Background Video",
                tab: basicTab,
            },
            {
                name: fields.title,
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                defaultValue: "",
                tab: basicTab,
            },
            {
                name: fields.description,
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                defaultValue: "",
                tab: basicTab,
            },
            {
                name: fields.blurEffect,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "20",
                tab: basicTab,
            },
            {
                name: fields.buttons,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        overriddenTitle,
                    } = item.fields;
                    if (overriddenTitle) {
                        return overriddenTitle;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } 
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linktype",
                        displayName: "Button Type",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "Link", value: "link" },
                            { displayName: "Video", value: "video" },
                            { displayName: "File", value: "file" },
                        ],
                        defaultValue: "link",
                        hideEmptyOption: true,
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isVisible: item => item.fields.linktype === "link",
                    },
                    {
                        name: "file",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        isVisible: item => item.fields.linktype === "file",
                    },
                    {
                        name: "video",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        isVisible: item => item.fields.linktype === "video",
                    },
                    {
                        name: "overriddenTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "openInNewTab",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                tab: advancedTab,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
